import { useEffect, useState } from 'react'
import { MissionType } from '../../../../domain/enum/mission-type.enum'
import { makePostMissionAnswer, makePutMissionAnswer } from '../../../../main/usecases/mission-answer/post-mission-answer-factory'
import { useGameWrapper } from '../../../contexts'
import { getAssetUrl } from '../../../utils/assets_helpers'
import { addAllowFullScreen, orderById, replaceInstructionsTags } from '../../../utils/mission_helpers'
import { getTeam } from '../../../utils/team_helpers'
import { replaceHtmlEntity } from '../../../utils/text_replace'
import ConnectDotsComponent from '../../connectDots'
import { IElementProps } from '../../diagram'
import { YoutubeCarousel } from '../../youtube_carousel'
import { Container, Image, Instructions } from '../styles'

const ConnectDotsMission = () => {
  const [instructions, setInstructions] = useState<string|null>('')
  const [uuid, setUuid] = useState<string>('')
  const [elements, setElements] = useState<IElementProps[]>([])
  const [status, setStatus] = useState<string>('')
  const [numberMinSelections, setNumberMinSelections] = useState<number>(1)
  const [connections, setConnections] = useState<any>({})
  const [newAnswers, setNewAnswers] = useState<any>([])
  const [options, setOptions] = useState<any>({
    source: [],
    target: []
  })

  const team = getTeam()
  const { timeout, attempts, currentMission, submitCallback, doSubmit, submitButtonIsEnabled, handleToggleStatusSubmitButton, setTimePaused } = useGameWrapper()

  async function initAnswer () {
    try {
      if (team.id && currentMission?.type !== MissionType.PICTURE) {
        const res = await makePostMissionAnswer().post({
          mission: currentMission?.uuid,
          team: team.id
        })
        setUuid(res['@id'] || '')
      }
    } catch (error) {
      console.error('OpenAnswerMission.sendAnswer', error)
    }
  }

  async function sendAnswer () {
    try {
      if (team.id) {
        let answersToSend: any = []
        Object.keys(newAnswers).forEach(key => {
          answersToSend.push({
            firstDescription: options?.source?.find((i:any) => i.columnId === Number(key))?.text,
            secondDescription: options?.target?.find((i:any) => i.columnId === Number(newAnswers[key]))?.text
          })
        })

        const missionAttempts = currentMission?.options?.attempts

        if (missionAttempts && missionAttempts > 1) {
          answersToSend = [...answersToSend, { attempts: (missionAttempts - attempts) + 1 }]
        }

        const res = await makePutMissionAnswer(uuid).update({
          answer: answersToSend,
          status: timeout ? 'timeout' : status
        })
        setConnections({})
        return res
      }
    } catch (error) {
      console.error('OpenAnswerMission.sendAnswer', error)
    }
  }

  function handleEnableButton () {
    if (Object.keys(connections).length >= numberMinSelections && Object.keys(connections).length > 0) {
      handleToggleStatusSubmitButton(true)
    } else {
      handleToggleStatusSubmitButton(false)
    }
  }

  function shuffleArray (arr:any) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]]
    }
    return arr
  }

  useEffect(() => {
    const answersArr:any = []
    const opts:any = []
    const source:any = []
    const target:any = []

    if (currentMission?.options?.answers) {
      Object.keys(currentMission?.options?.answers).forEach((key:any) => {
        answersArr.push(currentMission?.options?.answers[key])
      })
    }

    let tempIp = 0
    answersArr?.forEach((item:any, idx:number) => {
      tempIp = tempIp + 1
      source.push({
        id: tempIp,
        text: item.firstDescription,
        type: 'input',
        idElement: `input-${idx + 1}`,
        columnId: idx + 1
      })

      tempIp = tempIp + 1
      target.push({
        id: tempIp,
        text: item.secondDescription,
        type: 'output',
        idElement: `output-${idx + 1}`,
        columnId: idx + 1
      })
    })

    source.map((item:any, idx:number) => (
      opts.push(item)
    ))

    const randomIds:any = []
    const randomColumn:any = []
    shuffleArray(target).map((item:any) => (
      randomIds.push(item.id)
    ))

    target.sort(orderById).map((item:any, idx:any) => (
      randomColumn.push({
        ...item,
        id: randomIds[idx]
      })
    ))
    randomColumn.map((item:any) => (opts.push(item)))

    setElements(opts)
    setOptions({
      source: source,
      target: target
    })
  }, [currentMission])

  useEffect(() => {
    handleEnableButton()
    setNumberMinSelections(Number(currentMission?.options?.minSelections))
  }, [currentMission, connections])

  useEffect(() => {
    if (doSubmit && submitButtonIsEnabled) {
      submitCallback(sendAnswer)
    }
  }, [doSubmit, submitButtonIsEnabled])

  useEffect(() => {
    initAnswer()
  }, [JSON.stringify(currentMission?.uuid)])

  useEffect(() => {
    setConnections({})
    setStatus('responded')
    if (!currentMission) return
    const formattedInstructions = replaceInstructionsTags({ mission: currentMission, points: currentMission.pointsIfCorrect })
    setInstructions(addAllowFullScreen(formattedInstructions))
  }, [currentMission])

  useEffect(() => {
    if (timeout) {
      submitCallback(sendAnswer)
    }
  }, [timeout])

  useEffect(() => {
    setTimePaused(false)
  }, [])

  useEffect(() => {
    const div = document.getElementById('instructions')
    if (div) {
      div.innerHTML = replaceHtmlEntity(div.innerHTML)
    }
  }, [instructions])

  return (
    <Container>
      { currentMission?.icon && <Image src={getAssetUrl('icon', String(currentMission?.icon))} /> }
      {!!instructions && <Instructions id="instructions" dangerouslySetInnerHTML={
        { __html: instructions }
      } />}
      {currentMission?.options.video && <YoutubeCarousel videos={['https://www.youtube.com/embed/E7wJTI-1dvQ']}/>}
      <ConnectDotsComponent
        options={elements}
        setNewAnswers={setNewAnswers}
        connections={connections}
        setConnections={setConnections}
      />
    </Container>
  )
}

export default ConnectDotsMission
